import type {
  IDemo,
  IRecording,
  RecordingTypes,
  Workspace,
  WorkspaceFolder,
} from '@carboncopyco/types';
import constate from 'constate';

export type ClonePageProps = {
  rootPath: string;
  goBack: () => void;
  organizationId: string;
  cloneId: IRecording['id'];
  workspaceId: Workspace['id'];
  goToClone: (clone: IRecording) => void;
  goToCopiedClone: (
    cloneId: IRecording['id'],
    workspaceId: Workspace['id']
  ) => void;
  demoPagePath: (demoId: IDemo['id']) => string;
  goToDemoPage: (demoId: IDemo['id']) => void;
  handleClonePreview: (clone: IRecording) => void;
  openImportEditsModal: () => void;
  spliceCloneLdFlag: boolean;
  continueCloningProps: {
    onSelect: () => void;
    timeLeftToEditClone: string | null;
    ldFlag: number;
  };
  goToStudio: (studioLink: string) => void;
  goToEditor: (demoId: IDemo['id'], recordingType: RecordingTypes) => void;
  goToWorkspacePage: (workspaceId: Workspace['id']) => void;
  goToFolderPage?: (
    folderId: WorkspaceFolder['id'],
    workspaceId: Workspace['id']
  ) => void;
};

export type ClonePageState = ClonePageProps;

const useClonePage = (props: ClonePageState): ClonePageState => props;

export const [ClonePageProvider, useClonePageProps] = constate(useClonePage);
